import { IConstant } from 'types';
import { TCrystalConnectionStatus } from './types';

export const BASE_LIMIT_PER_PAGE = 20;
export const BASE_OFFSET = 0;

export const CONNECTION_STATUS_TEXT: IConstant<TCrystalConnectionStatus>[] = [
  {
    value: 'new',
    text: 'Новый',
  },
  {
    value: 'connected',
    text: 'Подключен',
  },
  {
    value: 'failure',
    text: 'Сбой',
  },
];
